<template>
  <div>
      <ad-account-campaign-list></ad-account-campaign-list>
      <new-campaign-form v-show="account.vendor === 'Quora'"></new-campaign-form>
      <ad-account-conversion-list v-show="hasConversions"></ad-account-conversion-list>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import AdAccountCampaignList from './AdAccountCampaignList.vue';
import AdAccountConversionList from './AdAccountConversionList.vue';
import NewCampaignForm from './NewCampaignForm.vue';

export default {
    components: {
        AdAccountCampaignList,
        AdAccountConversionList,
        NewCampaignForm,
    },

    computed: {
        ...mapGetters('client',{
            'account': 'activeAdAccount',
        }),

        hasConversions() {
            return ['AdWords','Bing Ads','Facebook','LinkedIn'].includes(this.account.vendor);
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/clients/AdAccountDetailsView.vue